import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { RequestsService } from 'src/app/core/services/requests.service';

@Injectable({
  providedIn: 'root'
})
export class VentayaService {
  constructor(
    private queriesService: QueriesService,
    private requestsService: RequestsService
  ) {
    // Constructor del servicio
  }

  async create(value): Promise<BasicResponse> {
    const result = await this.requestsService.postLikeJSON(
      // `${this.ENDPOINT}/JA/post`,
      `${getEndpoint('ventaya_url')}`,
      value
    );
    return result
  }
  async getPost() {
    const result = await this.requestsService.get(`${getEndpoint('ventaya_url')}/get/admin`)
    return result
  }
  async setState(id) {
    const result = await this.requestsService.get(`${getEndpoint('ventaya_url')}/${id}`)
    return result
  }
  // Agrega tus métodos y lógica aquí
}
